export type SiteMode = 'main' | 'merchant';

function parseSiteMode(value?: string | null): SiteMode | null {
  if (!value) {
    return null;
  }
  const modeToken = value.toLowerCase();
  if (modeToken === 'merchant') {
    return 'merchant';
  }
  if (modeToken === 'main' || modeToken === 'mall' || modeToken === 'site') {
    return 'main';
  }
  return null;
}

export function resolveSiteMode(): SiteMode {
  const envMode = parseSiteMode(process.env.REACT_APP_SITE);
  if (envMode) {
    return envMode;
  }

  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname.toLowerCase();
    if (hostname.startsWith('merchant.') || hostname === 'merchant.sjreet.com') {
      return 'merchant';
    }
  }

  return 'main';
}
